import React from "react";
import "./styles.scss";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { changeTab, changeLanguage } from "../../actions/general";
import { useTranslation } from "react-i18next";
import { toLangPath, hasEnPrefix, stripEnPrefix, getNavTab } from "../../utilities/helpers";

export default function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();

  const language = useSelector((state) => state.general.language);
  const { pathname } = useLocation();
  const activeTab = getNavTab(pathname);

  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isNavOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isNavOpen]);

  const navigateResponsive = (route) => {
    if (route) {
      const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
      navigate(toLangPath(route, lang));
      dispatch(changeTab(route.slice(1)));
    }
    setIsNavOpen(false);
  };

  return (
    <div className="header-wrapper">
      <div className="header-inner-wrapper">
        <div className="mobile">
          <div className={`nav ${isNavOpen ? "opened" : ""}`}>
            {!isNavOpen && (
              <div className="top-wrapper">
                <div className="logo-wrapper">
                  <img
                    src={require("../../assets/icons/logo.svg").default}
                    alt="logo"
                    height={70}
                    onClick={() => {
                      dispatch(changeTab("home"));
                      const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
                      navigate(toLangPath('/', lang));
                    }}
                  />
                </div>

                <div className="mobile-menu-icon" onClick={() => setIsNavOpen(true)} />
              </div>
            )}

            {isNavOpen && (
              <>
                <div className="top-wrapper">
                  <div className="logo-wrapper">
                    <img src={require("../../assets/icons/logo.svg").default} onClick={() => navigateResponsive('/')} alt="logo" />
                  </div>

                  <img className="close-icon" src={require("../../assets/icons/close-icon.svg").default} width="25" height="25" alt="close" onClick={() => setIsNavOpen(false)} />
                </div>

                <div className="opened-nav">
                  <li className={`option ${activeTab === "about" ? "active" : ""}`} onClick={() => navigateResponsive("/about")}>
                    {t("general.headerAbout")}
                  </li>
                  <li className={`option ${activeTab === "products-and-services" ? "active" : ""}`} onClick={() => navigateResponsive("/products-and-services")}>
                    {t("general.headerProductsAndServices")}
                  </li>
                  <li className={`option ${activeTab === "partners" ? "active" : ""}`} onClick={() => navigateResponsive("/partners")}>
                    {t("general.headerPartners")}
                  </li>
                  <li className={`option ${activeTab === "info" ? "active" : ""}`} onClick={() => navigateResponsive("/info")}>
                    {t("general.headerUsefulInfo")}
                  </li>
                  <li className={`option ${activeTab === "resources" ? "active" : ""}`} onClick={() => navigateResponsive("/resources")}>
                    {t("general.headerResources")}
                  </li>
                  <li className={`option ${activeTab === "contact" ? "active" : ""}`} onClick={() => navigateResponsive("/contact")}>
                    {t("general.headerContact")}
                  </li>

                  <button onClick={() => navigateResponsive("/offers")}>{t("general.getOffer")}</button>
                  <div className="languages-container">
                    <div
                      className={`lang ${language === "bg" ? "active" : ""}`}
                      onClick={() => {
                        dispatch(changeLanguage("bg"));
                        i18n.changeLanguage("bg");
                        const current = window.location.pathname;
                        navigate(stripEnPrefix(current));
                      }}
                    >
                      БГ
                    </div>
                    <div className="line">|</div>
                    <div
                      className={`lang ${language === "en" ? "active" : ""}`}
                      onClick={() => {
                        dispatch(changeLanguage("en"));
                        i18n.changeLanguage("en");
                        const current = window.location.pathname;
                        navigate(toLangPath(current, "en"));
                      }}
                    >
                      EN
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {isNavOpen && <div className="background-wrapper"></div>}
        </div>

        <div className="logo-wrapper desktop">
      <img
            src={require("../../assets/icons/logo.svg").default}
            alt="logo"
            onClick={() => {
              dispatch(changeTab("home"));
        const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
        navigate(toLangPath('/', lang));
            }}
          />
        </div>

        <div className="nav-wrapper border desktop">
          <NavLink
            to={toLangPath('/about', hasEnPrefix(window.location.pathname) ? 'en' : 'bg')}
            className={`nav-option ${activeTab === "about" ? "active" : ""}`}
            onClick={() => {
              dispatch(changeTab("about"));
              const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
              navigate(toLangPath('/about', lang));
              // setDropdown(false)
            }}
          >
            {t("general.headerAbout")}
          </NavLink>

          <NavLink
            to={toLangPath('/products-and-services', hasEnPrefix(window.location.pathname) ? 'en' : 'bg')}
            className={`nav-option ${activeTab === "products-and-services" ? "active" : ""}`}
            onClick={() => {
              dispatch(changeTab("products"));
              const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
              navigate(toLangPath('/products-and-services', lang));
              // setDropdown(false)
            }}
          >
            {t("general.headerProductsAndServices")}
          </NavLink>

          <NavLink
            to={toLangPath('/partners', hasEnPrefix(window.location.pathname) ? 'en' : 'bg')}
            className={`nav-option ${activeTab === "partners" ? "active" : ""}`}
            onClick={() => {
              dispatch(changeTab("partners"));
              const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
              navigate(toLangPath('/partners', lang));
              // setDropdown(false)
            }}
          >
            {t("general.headerPartners")}
          </NavLink>

          <NavLink
            to={toLangPath('/info', hasEnPrefix(window.location.pathname) ? 'en' : 'bg')}
            className={`nav-option ${activeTab === "info" ? "active" : ""}`}
            onClick={() => {
              dispatch(changeTab("info"));
              const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
              navigate(toLangPath('/info', lang));
              // setDropdown(false)
            }}
          >
            {t("general.headerUsefulInfo")}
          </NavLink>

          <NavLink
            to={toLangPath('/resources', hasEnPrefix(window.location.pathname) ? 'en' : 'bg')}
            className={`nav-option ${activeTab === "resources" ? "active" : ""}`}
            onClick={() => {
              dispatch(changeTab("resources"));
              // setDropdown(false)
            }}
          >
            {t("general.headerResources")}
          </NavLink>

          <NavLink
            to={toLangPath('/contact', hasEnPrefix(window.location.pathname) ? 'en' : 'bg')}
            className={`nav-option ${activeTab === "contact" ? "active" : ""}`}
            onClick={() => {
              dispatch(changeTab("contact"));
              const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
              navigate(toLangPath('/contact', lang));
              // setDropdown(false)
            }}
          >
            {t("general.headerContact")}
          </NavLink>
        </div>

        <div className="right-wrapper border desktop">
          <div className="divider" />
          <div className="flex">
            <button className="primary-bttn" onClick={() => {
              const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
              navigate(toLangPath('/offers', lang));
            }}> 
              {t("general.getOffer")}
            </button>

            <div className="languages-container">
        <div
                className={`lang ${language === "bg" ? "active" : ""}`}
                onClick={() => {
                  dispatch(changeLanguage("bg"));
                  i18n.changeLanguage("bg");
          const current = window.location.pathname;
          const to = stripEnPrefix(current);
          navigate(to);
                }}
              >
                БГ
              </div>

              <div className="line">|</div>

        <div
                className={`lang ${language === "en" ? "active" : ""}`}
                onClick={() => {
                  dispatch(changeLanguage("en"));
                  i18n.changeLanguage("en");
          const current = window.location.pathname;
          const to = toLangPath(current, 'en');
          navigate(to);
                }}
              >
                EN
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
